






import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import {
  HsaBankSsoLocationName,
  HsaBankSsoLocationParameter,
  HsabSsoDestination
} from "@/shared/types";
import { putSsoLinkClick } from "@/shared/api/userService";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";
import { useNotifierStore } from "@/shared/store/notifier";


@Component({
  components: {}
})
export default class SsoDeepLink extends Vue {

  @Prop({ required: true })
  deepLinkDestination: HsabSsoDestination;

  @Prop({ required: false })
  deepLinkParameters: HsaBankSsoLocationParameter[];

  isThinking = false;
  notifierStore = useNotifierStore();

  onClick () {
    if (this.isThinking) {
      return;
    }

    this.isThinking = true;
    const url = this.$router.currentRoute.path;
    const location: HsaBankSsoLocationName = {
      locationName: this.deepLinkDestination,
      isMobileApp: isMobileApp(),
      urlOfPageWithButton: url,
      locationParameters: this.deepLinkParameters,
    };


    putSsoLinkClick(location)
      .then(response => {
        if (!response.data || !response.data.samlProviderUrl) {
          this.notifierStore.setDanger("Sorry, that link isn't working right now. Please log out and back in again, or try again later.");
          return Promise.resolve();
        }

        if (isMobileApp()) {
          const options = "location=yes,hideurlbar=yes,toolbarposition=top,fullscreen=no";
          openUrl(response.data.samlProviderUrl, AppBrowserTarget.blank, options);
        } else {
          window.open(response.data.samlProviderUrl, "_blank");
        }

        return Promise.resolve();
      })
      .catch(err => {
        this.notifierStore.setDanger("Sorry, that link isn't working right now. Please log out and back in again, or try again later.");
        return Promise.resolve();
      })
      .finally(() => {
        this.isThinking = false;
      });
  }
}

